import { Trans } from "react-i18next";
import { SignUp } from "../../components/auth/SignUp";
import { LanguageSwitcher } from "../../components/languageSwitcher/languageSwitcher";
import "./SignUpPage.sass";

export const SignUpPage = () => {
  return (
    <section className="sign-up-page">
      <div className="sign-up-page__panel">
        <div className="sign-up-page__lang">
          <LanguageSwitcher showButtons={false} />
        </div>

        <div className="sign-up-page__header">
          <p className="sign-up-page__eyebrow">B2B Portal</p>
          <h1 className="sign-up-page__title">
            <Trans i18nKey="signUp" />
          </h1>
        </div>

        <SignUp />
      </div>
    </section>
  );
};
